import { Controller } from 'stimulus'

export default class OverlayController extends Controller {
  connect() {
    const id = this.element.getAttribute('id')
    console.log('OverlayController connected', id)

    const activators = document.querySelectorAll(`a[href="#${id}"]`)
    console.log(activators)
    activators.forEach((activator) => {
      activator.addEventListener('click', (e) => {
        e.preventDefault()
        this.open()
      })
    })
  }

  open(e = null) {
    if (e) e.preventDefault()
    this.element.classList.add('js-overlay--open')
  }

  close(e = null) {
    if (e) e.preventDefault()
    this.element.classList.remove('js-overlay--open')
  }

  toggle(e = null) {
    if (e) e.preventDefault()
    this.element.classList.toggle('js-overlay--open')
  }
}